<script setup lang="ts">
import { cn } from '../ui-utils.ts';
import { DialogTitle, type DialogTitleProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<DialogTitleProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <DialogTitle :class="cn('text-lg font-semibold text-slate-950', props.class)" v-bind="delegatedProps">
    <slot />
  </DialogTitle>
</template>
